import React, { useCallback } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import PropTypes from 'prop-types'

import { PERMISSIONS } from '../../../common/constants'

import { useUserHasPermissions } from '../../../account/hooks'
import { useDeleteFakeMenuMutation } from '../../hooks'

const MenuCurationTaskDeleteButton = ({ menuId }) => {
  const [deleteFakeMenu] = useDeleteFakeMenuMutation()

  const hasPermissionToDelete = useUserHasPermissions(
    PERMISSIONS.MENU_CURATION_TASK.DELETE,
  )

  const handleDelete = useCallback(() => {
    deleteFakeMenu(menuId)
  }, [deleteFakeMenu, menuId])

  return (
    <Popconfirm
      title="This action is irreversible. Are you sure you want to delete this task?"
      onConfirm={handleDelete}
      disabled={!hasPermissionToDelete}
    >
      <Button disabled={!hasPermissionToDelete} icon={<DeleteOutlined />} />
    </Popconfirm>
  )
}

MenuCurationTaskDeleteButton.propTypes = {
  menuId: PropTypes.string.isRequired,
}

export default MenuCurationTaskDeleteButton
